import { Box, SxProps, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";

interface TelegramSectionProps {
  title?: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
  action?: ReactNode;
}

export function TelegramSection({
  title,
  children,
  sx,
  containerSx,
  action,
}: TelegramSectionProps) {
  return (
    <Box sx={{ mb: 2.2, ...containerSx }}>
      {title && (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, px: action ? 0.5 : 2, mb: action ? 1 : 0.8 }}>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            textTransform: action ? "none" : "uppercase",
            fontSize: action ? "0.875rem" : "0.72rem",
            fontWeight: action ? 750 : 700,
            color: action ? "text.primary" : "text.secondary",
            letterSpacing: action ? 0 : "0.05em",
            minWidth: 0,
          }}
        >
          {title}
        </Typography>
        {action}
        </Box>
      )}
      <Box
        sx={{
          bgcolor: "background.paper",
          borderRadius: "12px",
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0 4px 16px -2px rgba(0, 0, 0, 0.25)"
              : "0 2px 12px -2px rgba(196, 140, 58, 0.06)",
          ...sx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default TelegramSection;
